import { render, staticRenderFns } from "./ZDHS.vue?vue&type=template&id=7a65050f&scoped=true"
import script from "./ZDHS.vue?vue&type=script&lang=js"
export * from "./ZDHS.vue?vue&type=script&lang=js"
import style0 from "./ZDHS.vue?vue&type=style&index=0&id=7a65050f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a65050f",
  null
  
)

export default component.exports